import { luscinia } from "./luscinia";

luscinia.downloadReportAndEmail = async function () {
    const formData = buildDownloadReportAndEmailFormData($("#download-report-email"));

    const parameterModal = document.querySelector(".modal-form") as HTMLFormElement;
    const reportName = parameterModal.dataset.reportName || "";
    const filterObjectId = parameterModal.dataset.filterObjectId || "";

    const response = await fetch(`/download-report-email/${reportName}`, {
        method: "POST",
        body: formData,
    });

    if (!response.ok) {
        throw new Error("Failed to process the report");
    }

    const data = await response.json();

    downloadPdf(data.pdfBase64, data.fileName);

    if (data.emailAddress) {
        luscinia.redirectToEmailClient(data.emailAddress, data.subject);
    } else {
        luscinia.showNotification("Warning", "Contact has no email address", "warning");
    }

    luscinia.closeAllModals();
};

export function buildDownloadReportAndEmailFormData(form: JQuery<HTMLFormElement>) {
    const formData = luscinia.serializeFormObject($(".modal-form"));
    const downloadEmailFormData = luscinia.serializeFormObject(form);

    for (const [key, val] of downloadEmailFormData.entries()) {
        formData.append(`download-and-email-report-${key}`, val);
    }

    return formData;
}

function downloadPdf(base64Data, fileName) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

luscinia.closeAllModals = function() {
    const allModals = $(".modal.edit-modal");
    allModals.each((index, el) => {
        const modal = $(el);
        modal.on("hidden.bs.modal", function (e) {
            modal.closest(".edit-modal").remove();
        });
        modal.modal("hide");
    });
}
